import { SearchTerm } from './SearchTerm';

const ZoneOccupancySearch: SearchTerm[] = [
    {
        heading: "Title",
        accessor: "title",
        searchOnName: "mstTitle",
        translationKey: "title",
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "mstDisplayname",
        translationKey: "displayName",
    },
    {
        heading: "Unique Identifier",
        accessor: "idNumber",
        searchOnName: "mstIdnumber",
        translationKey: "uniqueIdentifier",
    },
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "mstFirstname",
        translationKey: "firstName",
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        searchOnName: "mstMiddlename",
        translationKey: "secondName",
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        searchOnName: "mstLastname",
        translationKey: "lastName",
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        searchOnName: "mstSuffix",
        translationKey: "suffix",
    },
    {
        heading: "Department",
        accessor: "department",
        searchOnName: "deptName",
        translationKey: "department",
    },
    {
        heading: "Company",
        accessor: "company",
        searchOnName: "compName",
        translationKey: "company",
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "siteName",
        translationKey: "site",
    },
    {
        heading: "Zone",
        accessor: "zone",
        searchOnName: "zoneName",
        translationKey: "zone",
    },
    {
        heading: "Common Zone",
        accessor: "commonZone",
        searchOnName: "commonZoneName",
        translationKey: "commonZone",
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        searchOnName: "lastTrTagcode",
        translationKey: "tagCode"
    },
]

export default ZoneOccupancySearch;
